import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = {
  class: "input-form-label",
  for: "reject-reason"
}
const _hoisted_3 = { class: "flex gap-3" }

import { ref, watch } from "vue";
import Modal from "@/components/common/Modal.vue";
import Button from "@/components/common/Button.vue";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  show: { type: Boolean, default: false },
},
  setup(__props, { emit }: { emit: ({
  hide: [];
  confirm: [reason?: string];
}), expose: any, slots: any, attrs: any }) {

const props = __props





const reason = ref("");

watch(
  () => props.show,
  (visible) => {
    if (visible) {
      reason.value = "";
    }
  }
);

const submit = () => {
  emit("confirm", reason.value || undefined);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    show: __props.show,
    title: _unref(t)('entityApproval.rejectTitle'),
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(t)("entityApproval.rejectReason")), 1),
        _withDirectives(_createElementVNode("textarea", {
          id: "reject-reason",
          class: "input-form w-full mb-6",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reason).value = $event)),
          rows: "4"
        }, null, 512), [
          [_vModelText, reason.value]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Button, {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('hide')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(Button, {
            type: "submit",
            class: "bg-red-600"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("entityApproval.reject")), 1)
            ]),
            _: 1
          })
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})